export default "__VITE_ASSET__DfD6QSfE__"